import {
  Action,
  ActionType,
  SaveScheduleResponse,
} from "models/vaccine/schedules";
import createReducer from "../../createReducer";

export interface SaveScheduleReducerType {
  loading: boolean;
  error?: any;
  saved: boolean;
  saveScheduleResponse?: SaveScheduleResponse;
}

const defaultState: SaveScheduleReducerType = {
  loading: false,
  error: null,
  saved: false,
  saveScheduleResponse: undefined,
};

export const saveScheduleReducer = createReducer<SaveScheduleReducerType>(
  defaultState,
  {
    [ActionType.SAVE_SCHEDULE](state: SaveScheduleReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.SAVE_SCHEDULE_ERROR](
      state: SaveScheduleReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: action.payload,
      };
    },

    [ActionType.SAVE_SCHEDULE_SUCCESS](
      state: SaveScheduleReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: true,
        saveScheduleResponse: action.payload,
      };
    },

    [ActionType.SAVE_SCHEDULE_RESET](state: SaveScheduleReducerType) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: null,
        saveScheduleResponse: undefined,
      };
    },
  }
);
